import "datatables.net";
import "../components/hs-datatables";
import "flatpickr";
import "../components/hs-range-datepicker";
import "../components/hs-selectpicker";
import "../components/hs-chart-pie";
import "../components/hs-progress-bar";

export default {
  init() {

  },
  finalize() {
    $('#logoAndNav').hide();

    $(".add-listingto-cart").on("click", function () {
      var lp_id = $(this).data("lp-id");
      
      var action="add";
      var url = ajaxdta.ajaxurl + "?action=add_to_lpcart";
    
      $.ajax({
        type: "POST",
        url: url,
        data: {
          lp_id: lp_id, action:action
        },
        dataType:"JSON",
        success: function (data) { 
          var mString = data.count; 
          $("#inlist").show();
          $("#notinlist").hide(); 
          $("#addedtocartmessage").show();
          $("#addedtocartmessage").text('The listing is added to your shortlist');
          $("#addedtocartmessage").fadeOut(6000);             
        },
      });
    });
},
};


// WEBPACK FOOTER //
// ./scripts/routes/single-learning-pathway.js